export enum CHARACTER_STAT {
  HEALTH,
  ATTACK,
  DEFENCE
}

// TODO: подумать над статусами
export enum CHARACTER_STATUS {
  AVAILABLE,
  ELIMINATED,
  HIRED
}
